import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

// Components
import Heading from '../../../Heading';
import ToggleArrow from '../../../ToggleArrow';
import DesktopView from './DesktopView';
import MobileView from './MobileView';

// Styles
import styles from './Sauces.styl';

const cx = classNames.bind(styles);

export default function Sauces(props) {
  const { className, sauces, disabled, addToCart } = props;

  const intl = useIntl();
  const isPhone = useSelector(state => state.responsive.isPhone);
  const [isOpen, setIsOpen] = useState(false);

  const handleOnToggle = () => {
    setIsOpen(prev => !prev);
  };

  const handleOnHide = () => {
    setIsOpen(false);
  };

  const View = DesktopView;

  return (
    <div className={cx('Sauces', className)}>
      <Heading level={5} className={cx('Sauces__toggle')} onClick={handleOnToggle}>
        + {intl.formatMessage({ id: 'freeSauces.add' })}
        <ToggleArrow className={cx('Sauces__toggle-arrow')} isOpen={isOpen} />
      </Heading>
      <View
        sauces={sauces}
        disabled={disabled}
        addToCart={addToCart}
        isOpen={isOpen}
        onHide={handleOnHide}
      />
    </div>
  );
}

Sauces.defaultProps = {
  className: '',
};

Sauces.propTypes = {
  className: PropTypes.string,
  sauces: PropTypes.array.isRequired,
  addToCart: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};
